// extracted by mini-css-extract-plugin
export default {"main":"yj5rHjAv0U7RlHMzWr7F","loading":"xvimzcMdMIpAXeYEqzt3","common_bganimation":"elpc1Ony1uLFPqClndZK","customize":"qmK8iTLIKtJRQ4pYEXvM"};